import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useNotificationStore } from '@/stores/helpers/notification.js'
import SearchService from '@/services/admin/SearchService.js'
import { errorMessage } from '@/utilities/helpers.js'

export const useSearchStore = defineStore('adminSearch', () => {
  const notificationStore = useNotificationStore()

  const sendNotification = (type, message) => {
    notificationStore.add({ type, message })
  }
  // State
  const results = ref({})

  // Actions
  const search = async query => {
    try {
      const response = await SearchService.search(query)
      results.value = response
      return response
    } catch (err) {
      sendNotification('danger', errorMessage(err))
      throw err
    }
  }

  return {
    // State
    results,
    // Actions
    search
  }
})
